/* eslint-disable react-hooks/exhaustive-deps */
import { connect } from 'react-redux';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { FilterButton, Widget } from 'datastake-daf/dist/components';
import { actions } from '../../../../../../../store/reducers/dashboard';
import Loader from '../../widgets/loader';
import RecTable from '../../widgets/recTable';
import Style from './style';
import { filtersConfig, filtersData } from './helper';
import { CloseOutlined } from '@ant-design/icons';
import ModalFilters from '../progressive-modal-filters/filtersRow';
import { filterEvent, getMeasureStatus } from '../../widgets/recommendations';
import useFetchHelper from '../../../../../../../helpers/useFetchHelper';
import DashboardPopover from '../../../../../../../components/dashboards/components/Popover';

const Recommendations = ({
  t = (s) => s,
  data = null,
  PmeProjectGetWithFilters,
  organisationName,
  sources = [],
  valToResetFilters = null,
  allEvents = [],
  language,
  project,
  user,
  isOwnData,
  id,
}) => {
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [initialFetchIsDone, setInitialFetchIsDone] = useState(false);
  const [loadingRecs, setLoadingRecs] = useState(true);
  const [filtersVisible, setFiltersVisible] = useState(false);
  const [activeFilters, setActiveFilters] = useState({});
  const [clearFilters, setClearFilters] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const ref = useRef();
  const { canFetch } = useFetchHelper({ ref });
  const [admLevel2Name, setAdmLevel2Name] = useState('...');

  const clearFiltersClicked = () => {
    setActiveFilters({});
    setFiltersVisible(false);
    setClearFilters(true);
    setPage(1);
  };

  const isActive = useMemo(() => Object.keys(activeFilters).length > 0, [activeFilters]);

  const filteredSources = useMemo(() => {
    if (sources.length) {

      return sources.map((s) => ({
        value: s.authorId,
        label: s?.company?.name || s.sourceName || '',
      }));
    }
  }, [sources]);

  useEffect(() => {
    const { administrativeLevel2Labels } = data ? data.options : {}

    if (!isOwnData && administrativeLevel2Labels) {
      if (project) {
        if (administrativeLevel2Labels[project.country]) {
          setAdmLevel2Name(administrativeLevel2Labels[project.country][language] || 'Territory');
        }
      }
    }

    if (user &&
      administrativeLevel2Labels &&
      administrativeLevel2Labels[user.country]
    ) {
      setAdmLevel2Name(administrativeLevel2Labels[user.country][language] || 'Territory');
    }
  }, [data, project, language])

  const initialFilters = useMemo(() => filtersConfig.map((filter) => {
    switch (filter.type) {
      case 'select':
        if (filter.key === 'status') {
          return {
            ...filter,
            items: [
              { label: 'Proposed', value: 'proposed' },
              { label: 'In Progress', value: 'inProgress' },
              { label: 'Completed', value: 'completed' },
              // { label: 'Unplanned', value: 'unplanned' },
            ],
          }
        }
        if (data) {
          if (filter.key === 'sourceId') {
            return {
              ...filter,
              items: filteredSources,
            };
          }
          if (data.options[filter.optionsName || filter.key]) {
            return {
              ...filter,
              items: data.options[filter.optionsName || filter.key] || [],
            };
          }
        }
        if (filter.key === 'status') {
          return {
            ...filter,
          };
        }
        return {
          ...filter,
          items: filtersData[filter.optionsName || filter.key] || [],
        }
      case 'radioGroup':
        return {
          ...filter,
          items: filtersData[filter.optionsName || filter.key] || [],
        };
      case 'textInput':
        if (filter.key === 'admLevel2') {
          return {
            ...filter,
            label: admLevel2Name,
            placeholder: `${t('Type name of')} ${admLevel2Name}`
          }
        }
        return filter;
      default:
        return {};
    }
  }), [data, filteredSources, admLevel2Name]);

  const dataSource = useMemo(() => {
    if (data) {
      setInitialFetchIsDone(true);
      setTotal(data.metadata?.total || (data.records || []).length);
      return (data.records || []).map((d, i) => {
        const riskCategory = (data.options.riskCategory || []).find(opt =>
          opt.value === d.riskCategoryCamelCase
        );
        const riskType = (data.options.riskType || []).find(opt =>
          opt.value === d.riskTypeCamelCase
        );
        const responsibility = (d.linkedStakeholder || {}).name;

        return {
          key: i,
          ...d,
          riskType: riskType ? riskType.label : '-',
          responsibility,
          riskCategory: riskCategory ? riskCategory.label : '-',
          events: (d.events || []).map((e) => filterEvent(allEvents.find((ev) => ev.datastakeId === e), d.area)),
          status: getMeasureStatus(d),
        }
      });
    } else {
      setTotal(0);
      setInitialFetchIsDone(false);
    }
    return [];
  }, [data]);

  useEffect(() => {
    if (data === null) {
      setLoadingRecs(true);
    } else {
      setLoadingRecs(false);
    }
  }, [data]);

  useEffect(() => {
    if (canFetch) {
      PmeProjectGetWithFilters({
        filters: activeFilters,
        setLoading: setLoadingRecs,
        pagination: { page: 1, perPage: 8 },
        noReset: true,
        widget: 'recommendations',
        secondWidget: 'recommendationsOverview',
      });
      setPage(1);
      if (!loaded) {
        setLoaded(true);
      }
    }
  }, [activeFilters, language, canFetch]);

  useEffect(() => {
    if (loaded) {
      clearFiltersClicked();
    }
  }, [valToResetFilters]);

  return (
    <>
      <section ref={ref}>
        <Style id={id}>
          <Widget title={t('Risk Management Plan')}
            addedHeader={(
              <>
                <div className="flex-1" />
                <div className="flex-row">
                  {isActive && (
                    <div className="clear-filters flex-row" onClick={clearFiltersClicked}>
                      <div className="jus-c">
                        <CloseOutlined
                          className="close-icon"
                        />
                      </div>
                      <div className="jus-c">
                        <span className="clear-filters-span">{t('Dashboard::Clear filter(s)')}</span>
                      </div>
                    </div>
                  )}
                  <div className="jus-c">
                    <FilterButton
                      isActive={filtersVisible}
                      onClick={() => setFiltersVisible(prev => !prev)}
                    >
                      {t('Dashboard::Filter')}
                    </FilterButton>
                  </div>
                </div>
              </>
            )}
            tooltip={(
              <DashboardPopover
                title={t('Risk Management')}
                body={t('List of recommendations consolidated from all available information sources.')}
              />
            )}
          >
            <ModalFilters
              t={t}
              onSubmit={(f) => setActiveFilters(f)}
              className="widget-filters"
              initialFilters={initialFilters}
              setFiltersVisible={setFiltersVisible}
              setActiveFilters={setActiveFilters}
              clearFilters={clearFilters}
              setClearFilters={setClearFilters}
              filtersVisible={filtersVisible}
              activeFilters={activeFilters}
            />

            <div className="mt-2 flex-row">
              <RecTable
                page={page}
                total={total}
                dataSource={dataSource}
                PmeDashboardGetWithFilters={PmeProjectGetWithFilters}
                setLoading={setLoadingRecs}
                setPage={setPage}
                options={data ? data.options || {} : {}}
                initialFetchIsDone={initialFetchIsDone}
                t={t}
                isOwnData={false}
                isOverview={true}
                organisationName={organisationName}
                filters={activeFilters}
                project={project}
                language={language}
                maxHeight={100}
                minHeight={450}
              />
              {loadingRecs ? (
                <Loader />
              ) : null}
            </div>
          </Widget>
        </Style>
      </section>
    </>
  );
};

export default connect(null, actions)(Recommendations);
